
export default {
  name: "ComissaoVendedor",
  props: {
    dados: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  computed: {
    atingimento() {
      return Number(this.dados?.atingimento || 0);
    },
    progressWidth() {
      return `${Math.max(0, Math.min(100, this.atingimento))}%`;
    },
    scenarios() {
      return Array.isArray(this.dados?.cenarios) ? this.dados.cenarios : [];
    },
    nextRange() {
      return this.dados?.proxima_faixa || null;
    },
    currentCommissionLabel() {
      const range = this.dados?.faixa_atual;
      if (range) {
        return this.rangeCommissionLabel(range);
      }

      const vista = Number(this.dados?.regra?.percentual_vista || 0);
      const prazo = Number(this.dados?.regra?.percentual_prazo || 0);
      return vista === prazo
        ? `${this.percent(vista)} sobre as vendas`
        : "À vista + a prazo";
    },
    currentRangeLabel() {
      const range = this.dados?.faixa_atual;
      if (!range) return "Em construção";

      return `${this.percent(range.percentual_inicial)}${
        range.percentual_final != null
          ? `–${this.percent(range.percentual_final)}`
          : "+"
      }`;
    },
    currentRangeDetail() {
      const range = this.dados?.faixa_atual;
      if (!range) {
        return this.scenarios.length
          ? "Avance até a primeira faixa"
          : "Regra fixa de comissão";
      }

      return this.rangeCommissionLabel(range);
    },
    paceLabel() {
      if (this.atingimento >= 100) return "Meta batida";

      return `${this.money(this.dados?.ritmo?.necessario_por_dia)}/dia`;
    },
    paceDetail() {
      if (this.atingimento >= 100) return "Continue avançando nas faixas";

      return `${this.dados?.ritmo?.dias_restantes || 0} dias restantes`;
    },
  },
  methods: {
    money(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(value) || 0);
    },
    percent(value) {
      const number = Number(value) || 0;
      return `${new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: Number.isInteger(number) ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(number)}%`;
    },
    rangeCommissionLabel(range) {
      const vista = Number(
        range?.percentual_comissao_vista ?? range?.percentual_comissao ?? 0
      );
      const prazo = Number(range?.percentual_comissao_prazo ?? vista);

      return vista === prazo
        ? `${this.percent(vista)} de comissão`
        : `Vista ${this.percent(vista)} · prazo ${this.percent(prazo)}`;
    },
    rangeClass(range) {
      return {
        achieved: range.atingida && !range.atual,
        current: range.atual,
        next: range.proxima,
        locked: !range.atingida && !range.proxima,
      };
    },
    rangeStatus(range) {
      if (range.atual) return "Você está aqui";
      if (range.atingida) return "Conquistada";
      if (range.proxima) return `Faltam ${this.money(range.falta_vender)}`;
      return "Próxima etapa";
    },
    rangeIcon(range) {
      if (range.atual) return "geo-alt-fill";
      if (range.atingida) return "check-circle-fill";
      if (range.proxima) return "arrow-up-circle-fill";
      return "lock-fill";
    },
  },
};
